"use client";
import { store } from '@/lib/store';
import '@ant-design/v5-patch-for-react-19';
import { App, ConfigProvider, theme } from 'antd';
import { Provider } from 'jotai';
import { ThemeProvider as NextThemesProvider } from "next-themes";
import * as React from "react";
import { useDark } from '../hook/useDark';

export function ThemeProvider({ children, ...props }: React.ComponentProps<typeof NextThemesProvider>) {
  const isDark = useDark();

  return <NextThemesProvider {...props}>
    <Provider store={store}>
      <ConfigProvider theme={{
        algorithm: isDark ? theme.darkAlgorithm : theme.defaultAlgorithm,
      }}>
        <App className='h-full'>
          {children}
        </App>
      </ConfigProvider>
    </Provider>
  </NextThemesProvider>;
}
